export enum E_ShareType {
    TECH_MIND = 'TECH_MIND',
    SEEK_SEARCH = 'SEEK_SEARCH',
    TECH_RESEARCH = 'TECH_RESEARCH',
    NEWS_LETTER = 'NEWS_LETTER',
    AI_AGENT = 'AI_AGENT',
    PROJECT = 'WORK_PROJECT',
    AI_COMPANY_TECH_MONITOR = 'AI_COMPANY_TECH_MONITOR',
    TRIZ_MIND = 'TRIZ_MIND',
    AI_SEARCH = 'AI_SEARCH',
    RD_TECH_MIND = 'RD_TECH_MIND',
    RD_TECH_MIND_AGENT = 'RD_TECH_MIND_AGENT',
    TRIZ_PRO = 'TRIZ_PRO'
}

export enum ShareRole {
    OWNER = 'OWNER',
    COLLABORATOR = 'COLLABORATOR'
}

export interface ShareAuthRequiredData {
    id: string;
    type: E_ShareType;
    triggerButtonSource?: string;
}

export const SHARE_TYPE_MAP = {
    '': E_ShareType.SEEK_SEARCH,
    whiteboard: E_ShareType.TECH_MIND,
    project: E_ShareType.TECH_RESEARCH,
    newsletter: E_ShareType.NEWS_LETTER,
    ai: E_ShareType.AI_AGENT,
    graph: E_ShareType.PROJECT,
    monitor: E_ShareType.AI_COMPANY_TECH_MONITOR,
    triz: E_ShareType.TRIZ_MIND,
    techmind: E_ShareType.RD_TECH_MIND,
} as const

// 添加一个函数来获取分享路径
export function getSharePath(type: E_ShareType): string {
    for (const [path, shareType] of Object.entries(SHARE_TYPE_MAP)) {
        if (Array.isArray(shareType)) {
            if (shareType.includes(type)) {
                return path
            }
        } else if (shareType === type) {
            return path
        }
    }

    throw new Error(`Unknown share type: ${type}`)
}
